import PackageContext from '@/contexts/PackageContext';
import { useScopedField } from "@ngt/forms-core";
import { useContext, useEffect } from 'react';
import * as Dtos from '../api/dtos';
import { Session } from '../api/dtos';
import { useFormMetadata } from '@ngt/forms/src';


const RegistrationCostUpdater = () => {
    const {context: {setValue: setCost}} = useScopedField<number>("cost", {});
    const {
        state: {
            value: selectedSessions
        }
    } = useScopedField<Dtos.RegistrationSession[]>('sessions', {value: true});


    //free reg
    // custom reg ammount
    const {
        state: {
            value: customRegistration
        }
    } = useScopedField<boolean>('customRegistration', {value: true});
    const {
        state: {
            value: customPrice
        }
    } = useScopedField<number>('customPrice', {value: true});
    const {
        state: {
            value: freeRegistration
        }
    } = useScopedField<boolean>('freeRegistration', {value: true});


    const {package: packageInformation, isEarlyBird, additionalSessions} = useContext(PackageContext);


    useEffect(() => {
        let totalCost = 0

        if (freeRegistration)
        {
            setCost(totalCost);
            return;
        }

        if (customRegistration)
        {
            if (customPrice)
            {
                setCost(customPrice);
                return;
            }
        }

        if (!packageInformation) {
            setCost(totalCost);
            return;
        }

        if (isEarlyBird && packageInformation.discountPrice) {
            totalCost = packageInformation.discountPrice;
        } else {
            totalCost = packageInformation.price ?? 0;
        }

        if (!selectedSessions || selectedSessions.length === 0) {
            setCost(totalCost);
            return;
        }

        for (let selectedSession of selectedSessions ) {
            let sessionIncluded = true;
            let session: Session | undefined = packageInformation?.sessions?.find(x => x.id === selectedSession.sessionId);

            if (!session) {
                sessionIncluded = false;
                session = additionalSessions?.find(x => x.id === selectedSession.sessionId);
            }

            if (!session) {
                continue;
            }

            const sessionBaseCost = sessionIncluded ?
                0 :
                session.price ?? 0;

            const numberOfAdditional = session.additionalAttendees ? selectedSession?.numberOfAttendees ?? 0 : 0;
            const additionalPrice = session.additionalPrice ?? 0;

            const additionalAttendeesCost = (numberOfAdditional * additionalPrice);
    
            totalCost += sessionBaseCost + additionalAttendeesCost;

        }

        setCost(totalCost);
    }, [packageInformation, isEarlyBird, setCost, selectedSessions, additionalSessions, customRegistration, customPrice, freeRegistration])

    return null;
}

export default RegistrationCostUpdater;